import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
  // Get token from localStorage
  const token = localStorage.getItem("token");

  // ✅ If token exists, allow access to the protected route
  if (token) {
    return children;
  }

  // ❌ If no token, redirect to login
  return <Navigate to="/login" replace />;
}

export default ProtectedRoute;
